import styled from "styled-components";

export const Main = styled.main`
  display: flex;
  flex-direction: row;
  user-select: none;
`;
export const Section = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 90vh;
  user-select: none;
`;

interface ButtonProps {
  backgroundColor: string;
  hoverBackgroundColor: string;
  cursor?: string;
}

export const Button = styled.button<ButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  background-color: ${(props) => props.backgroundColor};
  cursor: ${(props) => props.cursor || "pointer"};
  border: none;
  padding: 10px;
  color: #fff;
  border-radius: 4px;
  font-weight: bold;
  &:hover {
    transition: all 0.2s;
    box-shadow: 0px 0px 4px black;
    background-color: ${(props) => props.hoverBackgroundColor};
  }
`;
